import React from 'react'
import { getTranslation } from '../translations'

function Field({ label, value, className = '' }) {
  return (
    <div className={`bg-[#e8f5e9] p-2 border border-white ${className}`}>
      <div className={`font-extrabold text-[#0f2f22] tracking-wide text-[11px] md:text-xs`}>{label}:</div>
      <div className="text-[#0a1f17] text-sm md:text-base mt-0.5 leading-snug">{value}</div>
    </div>
  )
}

export default function UserData({
  data,
  language = 'english',
}) {
  const t = getTranslation(language)
  
  return (
    <div className="w-full pl-2 pr-2">
      {/* Row 1 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-1">
        <Field label={t.name} value={data.name} />
        <Field label={t.mobile} value={data.mobile} />
        <Field label={t.address} value={data.address} />
        <Field label={t.cityState} value={data.cityState} />
      </div>

      {/* Row 2 */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-1 mt-1">
        <Field label={t.previousCrop} value={data.previousCrop} />
        <Field label={t.farmSize} value={data.farmSize} />
        <Field label={t.nextCrop} value={data.nextCrop} />
      </div>

      {/* Row 3 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-1 mt-1">
        <Field label={t.sampleCode} value={data.sampleCode} />
        <Field label={t.treatmentType} value={data.treatmentType} />
      </div>
    </div>
  )
}
